

























import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import IDoctor from '@/interfaces/doctor';
import { getDoctor } from '@/services/doctors';

@Component({
  components: { UiAutocompleClientsSubsidiaries, UiSelectDoctor },
})
export default class UiReferencesTypesHierarchyDoctor extends BaseComponent {
  @Prop()
  public item: any;
  @Prop({
    default: {
      doctor: [],
      clientUnit: [],
    },
  })
  public rules?: any;
  @Prop({
    default: false,
  })
  public disabled: boolean;

  public doctor = null;
  public doctorClients: any[] = [];


  @Watch('item', {immediate: true})
  onItemChange(item) {
    if (!this.item || !this.item.referenciaHierarquia) {
      return;
    }
    getDoctor(this.item.referenciaHierarquia).subscribe(res => {
      this.doctor = res;
    })
  }

  get clientUnit(): any {
    return this.item.unidade;
  }

  set clientUnit(val) {
    this.onChangeClientUnit(val);
  }

  public onChangeDoctor(val: IDoctor): void {
    if (!val) {
      return;
    }
    this.doctorClients = val.unidadesCliente;
    this.emitChangeClientUnit(null);
    this.$emit('changeDoctor', val);
  }

  public onChangeClientUnit(val: any): void {
    if (!val) {
      return;
    }
    this.emitChangeClientUnit(val);
  }

  private emitChangeClientUnit(val) {
    this.$emit('changeClientUnit', val);
  }

}
